import { getCoreAgentConversationHeaderSlice } from './get';

export const { requestGetCoreAgentConversationHeader } = getCoreAgentConversationHeaderSlice.asyncActionCreators;
